import { useState } from 'react';
import type { FormEvent } from 'react';
import { Button } from '~/components/ui/button';

type AdminLoginFormProps = {
    isLoading: boolean;
    errorMessage: string | null;
    onSubmit: (username: string, password: string) => Promise<void>;
};

export function AdminLoginForm({ isLoading, errorMessage, onSubmit }: AdminLoginFormProps) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const trimmedUsername = username.trim();
        if (!trimmedUsername || !password) {
            return;
        }

        await onSubmit(trimmedUsername, password);
    };

    return (
        <section className="w-full max-w-xl rounded-xl border border-orange-500/25 bg-linear-to-br from-zinc-950 to-zinc-900 p-4 shadow-2xl">
            <h1 className="text-xl md:text-2xl font-bold tracking-wide">Admin Access</h1>
            <p className="mt-1.5 text-sm text-orange-100/80">
                Sign in to manage cases, items, rarity, and uploads.
            </p>
            <form className="mt-6 space-y-4" onSubmit={(event) => void handleSubmit(event)}>
                <label className="grid gap-1.5 text-sm text-white/85">
                    <span>Username</span>
                    <input
                        type="text"
                        value={username}
                        onChange={(event) => {
                            setUsername(event.currentTarget.value);
                        }}
                        className="w-full rounded-lg border border-white/20 bg-black/50 px-2.5 py-2 text-white placeholder:text-white/45"
                        placeholder="admin"
                        autoComplete="username"
                    />
                </label>
                <label className="grid gap-1.5 text-sm text-white/85">
                    <span>Password</span>
                    <input
                        type="password"
                        value={password}
                        onChange={(event) => {
                            setPassword(event.currentTarget.value);
                        }}
                        className="w-full rounded-lg border border-white/20 bg-black/50 px-2.5 py-2 text-white placeholder:text-white/45"
                        placeholder="••••••••"
                    />
                </label>
                {errorMessage && <p className="text-sm text-red-300">{errorMessage}</p>}
                <Button type="submit" size="lg" disabled={isLoading} className="w-full">
                    {isLoading ? 'Signing in...' : 'Sign in'}
                </Button>
            </form>
        </section>
    );
}
